<div class="relative rounded-md bg-white group">
  <ng-content/>
</div>

<ng-content select="[tips]"></ng-content>
